const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  filterEventId: () => null,
  eventId: (lambdaParameter, value, otherValues) =>
    otherValues?.filterEventId === false
      ? null
      : `${lambdaParameter}.Events.Any(e=>e.Id.Equals(${value}))`,
  filterDynamicStatisticId: () => null,
  dynamicStatisticId: (lambdaParameter, value, otherValues) =>
    otherValues?.filterDynamicStatisticId === false
      ? null
      : `${lambdaParameter}.DynamicStatistics.Any(u=>u.Id.Equals(${value}))`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
